export default {
  blacklistedOriginators: [],

  loadingBlacklistOriginators: false,
  loadingBlacklistOriginatorsFailed: false,
  loadingBlacklistOriginatorsSucceeded: false,
  loadingBlacklistOriginatorsError: null,

  creatingBlacklistOriginator: false,
  creatingBlacklistOriginatorSucceeded: false,
  creatingBlacklistOriginatorFailed: false,

  deletingBlacklistOriginator: false,
  deletingBlacklistOriginatorSucceeded: false,
  deletingBlacklistOriginatorFailed: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/blacklist/state.js